import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import HistorySection from 'Components/HistorySection';
import HistoryRowListing from 'Components/HistoryRowListing';
import { Container, Item } from 'Components/Grid';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import HistoryRowControls from 'Components/HistoryRowControls';
import { adl, TADLLevel } from 'neuro-schemas/adl';
import { arrayOfAll } from 'neuro-utils';

const { calculateADLTotal } = adl.utils;

const adlLevelOptions = arrayOfAll.options<TADLLevel>()(['0', '1', '2', '3', 'unknown']);

const ADLHistory = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id={'diagnosticSurvey.adl.title'} />}
      newButton={
        <DocumentCreationButton
          name="adl"
          text={'diagnosticSurvey.adl.newADL'}
          onClick={startEdit({}, 'adl')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <Item xs={true}>
            <Container>
              {adlLevelOptions.map((level, index) => (
                <Item key={level + index} xs={2} style={{ paddingRight: '2rem' }}>
                  <FormattedMessage id={`diagnosticSurvey.adl.levels.${level}`} />
                </Item>
              ))}
            </Container>
          </Item>
        }
        contentFormat={(d): React.JSX.Element => (
          <Item xs={true}>
            <Container>
              {adlLevelOptions.map((level, index) => (
                <Item key={level + index} xs={2}>
                  {calculateADLTotal(d, level) ?? '-'}
                </Item>
              ))}
            </Container>
          </Item>
        )}
        makeDate
        makeControls
        historyRowControls={d => <HistoryRowControls document={d} startEdit={startEdit} view={view} />}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'adl'>[];
  startEdit: StartEdit<IDocumentWithTypeV2<'adl'>>;
  view?: IView;
}

export default ADLHistory;
